<div class="container p-4 my-5">
    <h3 class="d-flex justify-content-center lime-green-button text-white rounded-pill p-3 fs-5">
      <fa-icon class="me-2 fa-lg" [icon]="faTractor"></fa-icon>Lokalne kmetije</h3>
      <div *ngIf="allFarms.length === 0" class="col-12 d-flex justify-content-center" style="color: gray; font-style: italic;">
        <h2 class="text-center my-5">Na žalost ni ponudnikov.</h2>
      </div>
    <div class="row g-3">
      <div class="col-md-4" *ngFor="let farm of allFarms">
        <div class="farm-item card p-3 fixed-card-size">
          <!-- Farm Image -->
          <img [src]="farmDefaultImageUrl" alt="{{ farm.name }}" class="farm-image img-fluid mb-3 rounded">
          
          <!-- Farm Name -->
          <h5 class="farm-name">{{ farm.name }}</h5>
          
          <!-- Farm Address -->
          <p class="farm-address"><fa-icon class="me-2 fa-lg" [icon]="faLocationDot"></fa-icon>{{ farm.address }}</p>
  
          <!-- Farm Description -->
          <p class="description">
            {{ getTruncatedDescription(farm.description) }}
            <span *ngIf="farm.description.length > 120">
              ... <a [routerLink]="['/admin-farm-profile', farm.farmID]" class="lime-green-link">Preberi več</a>
            </span>
          </p>          
          
          <!-- Buttons -->
          <div class="card-footer mt-auto bg-white">
            <!-- First Row of Buttons -->
            <div class="row">
              <div class="col">
                <button [routerLink]="['/admin-farm-profile', farm.farmID]" class="btn lime-green-button mt-2 w-100">Preglej profil</button>
              </div>
              <div class="col" *ngIf="!isOnAdminPage">
                <button class="btn btn-primary mt-2 w-100" (click)="subscribeToFarm(farm)">Sledi kmetiji</button>
              </div>
            </div>
            
            <!-- Second Row of Buttons -->
            <div class="row mt-2" *ngIf="isOnAdminPage">
              <div class="col">
                <button class="btn btn-secondary mt-2 w-100" (click)="deleteFarm(farm.farmID)">Izbriši</button>
              </div>
              <div class="col">
                <button class="btn btn-secondary mt-2 w-100" (click)="openSendAdminMessageModal(farm.farmID)">Obvesti</button>
              </div>
            </div>
          </div>
          
        </div>
      </div>
    </div>
  </div>